module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAAD///////////////////////////////////////////+0CY3pAAAAC3RSTlMA9D5COpTd3NfVjXV3qj4AAABlSURBVBjTYyAPhCuASOZUMKdaCEQa7gRzFDcqACWkRcAcJmkhoMRGBwaYFFgCJgWWgEmBJOBScAmQUUADIQBklLQQQkJEESoFtoMJIgW1HCIFtRwmlS0CtmsHmBPpALari7wAAABO9hK1zPnzlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close_white.png
// module id = 92
// module chunks = 1